import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { XCircle, CheckCircle2, ArrowRight } from 'lucide-react';
export function TransformationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const before = ['No podés correr 2 minutos seguidos', 'Te sentís frustrado y sin energía', 'Abandonás cada vez que intentás', 'Creés que "no es para vos"'];
  const after = ['Corrés 5K completos sin parar', 'Te sentís capaz y orgulloso', 'Tenés un hábito que mantener', 'Sabés que SÍ podés lograrlo'];
  return <section ref={ref} className="py-20 px-4 bg-navy-light" data-id="element-169">
      <div className="max-w-6xl mx-auto" data-id="element-170">
        <motion.h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4 text-center leading-tight" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-171">
          Imaginate esto en solo <span className="text-accent" data-id="element-172">8 semanas</span>
        </motion.h2>

        <motion.p className="text-xl text-center text-accent font-bold mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-173">
          SIN experiencia previa
        </motion.p>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-174">
          {/* BEFORE */}
          <motion.div className="bg-navy p-8 rounded-2xl border-2 border-red-500/30" initial={{
          opacity: 0,
          x: -50
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-175">
            <div className="flex items-center gap-3 mb-6" data-id="element-176">
              <XCircle className="text-red-500" size={32} data-id="element-177" />
              <h3 className="text-3xl font-black text-red-500" data-id="element-178">ANTES</h3>
            </div>
            <div className="space-y-4" data-id="element-179">
              {before.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-180">
                  <XCircle className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-181" />
                  <p className="text-gray-300 text-lg" data-id="element-182">{item}</p>
                </div>)}
            </div>
          </motion.div>

          {/* Arrow */}
          <motion.div className="hidden md:flex justify-center" initial={{
          opacity: 0,
          scale: 0.5
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-183">
            <ArrowRight className="text-accent" size={64} data-id="element-184" />
          </motion.div>

          {/* AFTER */}
          <motion.div className="bg-navy p-8 rounded-2xl border-2 border-accent/50 md:col-start-2" initial={{
          opacity: 0,
          x: 50
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-185">
            <div className="flex items-center gap-3 mb-6" data-id="element-186">
              <CheckCircle2 className="text-accent" size={32} data-id="element-187" />
              <h3 className="text-3xl font-black text-accent" data-id="element-188">DESPUÉS</h3>
            </div>
            <div className="space-y-4" data-id="element-189">
              {after.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-190">
                  <CheckCircle2 className="text-accent flex-shrink-0 mt-1" size={20} data-id="element-191" />
                  <p className="text-white text-lg font-semibold" data-id="element-192">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}